import { Stack, Typography } from '@mui/material';
import type { BaseModalProps, ServiceGuideModalType } from '@/interfaces/component/modal.interface';
import FlexBox from '@/components/FlexBox';
import BaseModal from '@/components/modal/BaseModal';
import reviewModalTextContainer from '@/json/modal/review.json';

const ServiceGuideModalResolver = (
  props: BaseModalProps & {
    modalKey: ServiceGuideModalType | undefined;
  }
) => {
  const { modalKey, ...modalProps } = props;

  if (!modalProps.showModal || modalKey === undefined) {
    return '';
  }

  const modalTextContainer: {
    modalTitle: string;
    description?: string;
    contents: { title: string; descriptions: string[] }[];
  } = reviewModalTextContainer[modalKey];

  if (!modalTextContainer) {
    return '';
  }

  const { modalTitle, description = undefined, contents } = modalTextContainer;

  return (
    <BaseModal {...modalProps} modalTitle={modalTitle}>
      <Stack paddingX="16px" gap={'16px'}>
        {description ? <Typography variant="body1">{description}</Typography> : ''}
        {contents.map(({ title, descriptions }, i) => (
          <Stack key={i}>
            <Typography variant="subtitle1" fontWeight={600}>
              {title}
            </Typography>
            <Stack>
              {descriptions.map((_description) => (
                <FlexBox key={`${modalKey}-${i}`} style={{ gap: '8px', alignItems: 'start' }}>
                  <Typography>•</Typography>
                  <Typography flex={'1 0 0'} variant="body1">{` ${_description}`}</Typography>
                </FlexBox>
              ))}
            </Stack>
          </Stack>
        ))}
      </Stack>
    </BaseModal>
  );
};

export default ServiceGuideModalResolver;
